import React, { Component } from 'react';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { bookingFormInitialValues } from '../../store/reducers';
import CounterInput from '../CounterInput';

import { getBoardBasePrice, getNoOfSelectedGuestsByGuestType } from "../../apiHelpers";
import withLocalize from "../../withLocalize";
import { SANDAMIANO_HOTEL_ID } from "../../utils";

class BoardBaseOffer extends Component {

	render() {
		const { boardBase, formValues, guestTypes, hotelId, translate: t, translatePropertyValue} = this.props;

		if (!boardBase) return null;

		const price = getBoardBasePrice(boardBase, formValues.currency, false);
		const formattedPrice = getBoardBasePrice(boardBase, formValues.currency);
		const perDaySuffix = hotelId === SANDAMIANO_HOTEL_ID ? t('BoardBaseOffer.perDay') : '';

		return (
			<div className={`room-offer ${this.props.isLast ? 'room-offer--last' : ''}`}>
				<div className="room-offer__text-container">
					<h2 className="room-offer__room-name">{t('BoardBase.' + boardBase.id)} {price ? ` (+ ${formattedPrice}${perDaySuffix})` : null}</h2>

					<br />

					{Object.values(guestTypes).map((guestType, index) =>
						!guestType.exclude ? <Field
							component={CounterInput}
							name={`boardBase[${boardBase.id}][${guestType.id}]`}
							className="large-input--inline"
							label={translatePropertyValue(guestType.name)}
							max={getNoOfSelectedGuestsByGuestType(formValues, guestType.id)}
							key={index}
						/> : ''
					)}
				</div>
			</div>
		);
	}
}

export default compose(
	connect(state => ({
		formValues: getFormValues('bookingForm')(state),
		guestTypes: state.app.guestTypes,
		hotelId: state.app.hotelId,
	})),
	reduxForm({
		form: 'bookingForm',
		initialValues: bookingFormInitialValues,
		destroyOnUnmount: false,
	}),
	withLocalize,
)(BoardBaseOffer);



// WEBPACK FOOTER //
// ./src/components/BoardBases/BoardBaseOffer.jsx